module.exports = __webpack_public_path__ + "static/media/placeholder-avatar-background.ecf25794.svg";